import { Component, ViewChild } from '@angular/core';
import { NgbTabset } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-permissoes-tabset',
  templateUrl: './permissoes-tabset.component.html',
  styleUrls: ['./permissoes-tabset.component.css']
})
export class PermissoesTabsetComponent {
  @ViewChild('tabset', { read: NgbTabset, }) tabset: NgbTabset;

  constructor() {
  }

  voltar(): void {
    if (this.tabset) {
      this.tabset.select('grupo-acesso');
    }
  }
}




// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/permissoes-acesso/permissoes-tabset/permissoes-tabset.component.ts